import { render, staticRenderFns } from "./Initializing.vue?vue&type=template&id=3bda5870&scoped=true&"
import script from "./Initializing.vue?vue&type=script&lang=js&"
export * from "./Initializing.vue?vue&type=script&lang=js&"
import style0 from "./Initializing.vue?vue&type=style&index=0&id=3bda5870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda5870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bda5870')) {
      api.createRecord('3bda5870', component.options)
    } else {
      api.reload('3bda5870', component.options)
    }
    module.hot.accept("./Initializing.vue?vue&type=template&id=3bda5870&scoped=true&", function () {
      api.rerender('3bda5870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/Initializing.vue"
export default component.exports